import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import actions from 'redux/actions'
import { modals } from 'helpers'

import Box from 'components/layout/Box/Box'
import Modal from 'components/Modal/Modal'

import s from './EditableModal.scss'
import EditableTable from 'components/EditableTable/EditableTable'


class EditableModal extends PureComponent {

  static propTypes = {
    name: PropTypes.string.isRequired,
    data: PropTypes.object.isRequired,
  }

  static defaultProps = {
    name: modals.Editable,
  }

  submit = (data) => {
    const { data: { onSubmit } } = this.props

    this.close()
    onSubmit(data)
  }

  close = () => {
    const { name, data: { onClose } } = this.props

    actions.modals.close(name)

    if (typeof onClose === 'function') {
      onClose()
    }
  }

  render() {
    const { data } = this.props

    return (
      <Modal
        containerClassName={s.container}
        onClose={this.close}
      >
        <div>
          <div className={s.title}>{data.title}</div>
          {
            Boolean(data.text) && (
              <Box pt="sm">
                <div className={s.text}>{data.text}</div>
              </Box>
            )
          }
          <EditableTable
            {...data}
            fieldsRows={[ data.fields ]}
            onSubmit={this.submit}
          />
          {
            Boolean(data.bottomText) && (
              <Box pt="sm">
                <div className={s.text} dangerouslySetInnerHTML={{ __html: data.bottomText }} />
              </Box>
            )
          }
        </div>
      </Modal>
    )
  }
}


export default EditableModal
